import { React } from "react";
import { connect } from "react-redux";
import "./style.css";
import { useContext } from "react";
import FeedbackContext from "../../context/cmscontext";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
} from "react-icons/fa";

const trim = (str) => (str || "").trim();

const SOCIAL_LINKS = [
  {
    href: "https://www.facebook.com/carfirstpk/",
    label: "Facebook",
    Icon: FaFacebookF,
    platform: "facebook",
  },
  {
    href: "https://www.youtube.com/channel/UCMTFXYdUJO4p3KDDnrGHPDw?sub_confirmation=1",
    label: "YouTube",
    Icon: FaYoutube,
    platform: "youtube",
  },
  {
    href: "https://pk.linkedin.com/company/carfirst",
    label: "LinkedIn",
    Icon: FaLinkedinIn,
    platform: "linkedin",
  },
  {
    href: "https://www.instagram.com/carfirstpk/",
    label: "Instagram",
    Icon: FaInstagram,
    platform: "instagram",
  },
];

export const FoterMini = () => {
  const { feedback } = useContext(FeedbackContext);
  const home_page = feedback.home_page;
  const currentYear = new Date().getFullYear();

  return (
    <div className="footer-v2__bar">
      <div className="footer-v2__bar-inner">
        <p className="footer-v2__copy">
          © <strong>{currentYear}</strong> AutoTrade Port.{trim(home_page.All_right_text)}
        </p>
        <div className="footer-v2__social pi-footer__social">
          {SOCIAL_LINKS.map(({ href, label, Icon, platform }) => (
            <a
              key={href}
              href={href}
              className={`footer-v2__social-link pi-footer__social-link pi-footer__social-link--${platform}`}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={label}
            >
              <Icon aria-hidden />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  home_page: state.datafile.home_page,
});

export default connect(mapStateToProps, null)(FoterMini);
